<template>
  <div>
    <select-field
      v-model="_value"
      :options="options"
      :loading="loading"
    />

    <o-dialog
      ref="dialog"
      :title="$t('components.roles.elements.select.title')"
      :info="$t('components.roles.elements.select.info')"
      :options="[
        { text: $t('general.cancel'), type: 'cancel', callback: cancelChange },
        { text: $t('general.confirm'), type: 'confirm' }
      ]"
      :portal="portal"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

import {
  SelectField,
} from '@/components/fields'

import { Role } from '~/_api/models/role'


interface Props {
  modelValue?: any
  defaultValue?: any
  portal?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  defaultValue: null,
  portal: undefined,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const { $api } = useNuxtApp()
const instance = getCurrentInstance()

const roles = ref<any[]>([])
const builtIns = ref<any[]>([])
const options = ref<any[]>([])
const loading = ref(true)
const legacy = ref<any>(null)
const dialog = ref<any>()

const _value = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    if (props.modelValue?.name === 'Legacy' && value?.name !== 'Legacy') {
      dialog.value?.open()
    }

    emit('update:modelValue', value)
  },
})

async function fetchRoles () {
  if (!(instance?.proxy as any)?.$features?.get('custom-roles')) {
    roles.value = []
    return
  }
  try {
    const response = await $api.role.list()
    roles.value = response?.items ?? []
  } catch (e) {
    console.error(e)
  }
}

async function fetchBuiltIns () {
  try {
    const response = await $api.role.builtIns()
    builtIns.value = response?.items ?? []
  } catch (e) {
    console.error(e)
  }
}

function setOptions () {
  const opts = [...roles.value, ...builtIns.value]
    .map((role: any) => {
      const { employees, ...rest } = role as any
      const value = new Role(rest)

      return {
        label: role.name,
        value,
      }
    })

  if (props.modelValue?.name === 'Legacy') {
    legacy.value = { ...props.modelValue }

    opts.unshift({
      label: 'Legacy',
      value: props.modelValue,
    })
  }

  if (props.modelValue) {
    const role = opts
      .find(option => option.value.name === props.modelValue.name)

    _value.value = role?.value
  }

  options.value = opts
}

function cancelChange () {
  _value.value = legacy.value

  return true
}

// created logic
;(async () => {
  await fetchRoles()
  await fetchBuiltIns()

  setOptions()

  if (props.defaultValue) {
    const role = options.value
      .find(option => option.value.name === props.defaultValue.name)

    _value.value = role?.value
  }

  loading.value = false
})()
</script>
